import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import Swal from 'sweetalert2'
import { CtbCcService, Ctbcc } from '../ctb-cc.service';
import { LoginService } from '../../../login/login.service';
import { CtbCtaService, CtbCtaDto, PageBusquedaObject  }from '../../ctb-cta/ctb-cta.service';

@Component({
  selector: 'app-formulario-ctb-cc',
  templateUrl: './formulario-ctb-cc.component.html',
  styleUrls: ['./formulario-ctb-cc.component.css'],
  preserveWhitespaces: true
})
export class FormularioCtbCcComponent implements OnInit {

  public id_param: number;
  public cc: Ctbcc = new Ctbcc();
  errors: String[];

  busqueda: PageBusquedaObject = new PageBusquedaObject();
  totalItems: number;
  rotate: any;
  items: CtbCtaDto[] = [];
  tipoCuenta: any[];

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    public loginService: LoginService,
    private service: CtbCcService, private ctaService:CtbCtaService
  ) { }

  ngOnInit() {
    this.busqueda.criteriaSearch = {};
    this.busqueda.criteriaSearch['ctb_cc_id'] = this.id_param;
    this.busqueda.itemsPerPage = 5;
    this.busqueda.pageNumber = 0;
    this.cargarTiposCuenta();
    this.activatedRoute.params.subscribe(params => {
      this.id_param = params['id'];
      if (this.id_param) {
        this.mostrarMensajeCarga();
        this.service.getConcepto(this.id_param).subscribe(response => {
          this.cc = response.contenido;
          this.cerrarMensajeCarga();
        }, err => {
          this.cerrarMensajeCarga();
          if (err.error.mensaje == null || '' || undefined) {
            err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
          }
          Swal.fire({
            icon: 'error',
            title: 'TNK Ledger',
            text: err.error.mensaje
          })
          console.log(err);
        });
      }
    });
  }

  validarBusquedaCuentas(){
    if(!this.id_param){
      this.crear(false);
    } else {
      if(this.items.length == 0){
        this.busqueda.criteriaSearch['ctb_cc_id'] = this.id_param;
      this.cargarCatalogo();
      }
    }
  }



  crear(navegar: boolean) {
    this.cc.gral_emp_id = this.loginService.empresa;
    this.cc.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.service.post(this.cc).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      if(navegar == true){
      this.router.navigate(['/contabilidad/catalogo/ctb-cc']);
      } else {
        this.id_param = response.contenido.id;
        this.cc.id = this.id_param;
        this.busqueda.criteriaSearch['ctb_cc_id'] = this.id_param;
        this.cargarCatalogo();
      }
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }

  actualizar() {
    this.cc.gral_emp_id = this.loginService.empresa;
    this.cc.gralUsrActualizaId = this.loginService.usuario.id as number;
    this.service.put(this.cc).subscribe(response => {
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      this.router.navigate(['/contabilidad/catalogo/ctb-cc']);
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      this.errors = err.error.error;
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  cargarTiposCuenta() {
    this.ctaService.getTipo().subscribe(response => {
      this.tipoCuenta = response.contenido;
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  relacionarCc(CtbCtaId: number, CtbCcId: number){
    this.ctaService.actualizarCc(CtbCtaId, CtbCcId, this.loginService.usuario.id).subscribe(
      response =>{
      Swal.fire('TNK Ledger', response.mensaje, 'success');
      }
    );;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  guardarRelacionCc(id:number, index:number){
    this.items[index].ctb_cc_id = this.id_param;
    this.relacionarCc(id,this.id_param);
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  retirarRelacionCc(id:number, index:number){
    this.items[index].ctb_cc_id = 0;
    this.relacionarCc(id, 0);
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  cargarCatalogo() {
    this.busqueda.criteriaSearch['suc'] = this.loginService.sucursal;
    this.busqueda.criteriaSearch['emp'] = this.loginService.empresa;
    this.busqueda.criteriaSearch['clasificacion'] = 4;
    this.ctaService.ctaCatalogo(this.busqueda).subscribe(response => {
      this.items = response.contenido.content;
      this.totalItems = response.contenido.totalElements;
      this.cerrarMensajeCarga();
    }, err => {
      if (err.error.mensaje == null || '' || undefined) {
        err.error.mensaje = 'Ha ocurrido un error con la conexión al servidor';
      }
      Swal.fire({
        icon: 'error',
        title: 'TNK Ledger',
        text: err.error.mensaje
      })
      console.log(err);
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  cambiarPagina(event: any): void {
    this.busqueda.pageNumber = event.page - 1;
    this.cargarCatalogo();
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  filtroDeBusqueda(find: any, columnName: any): void {
    this.busqueda.criteriaSearch[columnName] = find;
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  sortearPor(columnName: any): void {
    this.busqueda.column = columnName;
    this.busqueda.sort = true;
    this.busqueda.pageNumber = 0;
    switch (this.busqueda.order) {
      case 'desc':
        this.busqueda.order = 'asc';
        break;
      default:
        this.busqueda.order = 'desc';
        break;
    }
    this.cargarCatalogo();
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  buscarEnCatalogo(): void {
    this.busqueda.pageNumber = 0;
    this.cargarCatalogo();
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  limpiarBusqueda(): void {
    this.busqueda.criteriaSearch = {};
    this.busqueda.criteriaSearch['ctb_cc_id'] = this.id_param;
    this.buscarEnCatalogo();
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  mostrarMensajeCarga() {
    Swal.fire({
      title: 'TNK Ledger',
      html: 'Procesando...',
      timerProgressBar: true,
      showConfirmButton: false,
allowOutsideClick: false,
      onBeforeOpen: () => {
        Swal.showLoading()
      }
    });
  }
  ////////////////////////////////////////////////////////////////////////////////////////////////////////////////
  cerrarMensajeCarga() {
    Swal.close();
  }
}
